"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardSurface = BoardSurface;
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const sessionContext_1 = require("~/game/sessionContext");
const plugins_1 = require("~/plugins");
const GameBoard_1 = require("./GameBoard");
const boardSurfaceConfig_1 = require("./boardSurfaceConfig");
const hooks_1 = require("./hooks");
const ProjectileCanvas_1 = require("./projectiles/ProjectileCanvas");
function BoardSurface({ children }) {
    const phase = (0, react_redux_1.useSelector)((state) => state.game.roundInfo.phase);
    const spectatingId = (0, react_redux_1.useSelector)((state) => state.game.spectating.id);
    const config = (0, boardSurfaceConfig_1.getBoardSurfaceConfig)({ phase, spectatingId });
    const session = (0, sessionContext_1.useGameSession)();
    const surfaceBoard = config.isMatch ? session.battle.board : session.board;
    const { bench, pieceRegistry } = session;
    const renderSelectable = (0, hooks_1.useRenderSelectablePiece)();
    const renderReadOnly = (0, hooks_1.useRenderReadOnlyPiece)();
    const renderMatch = (0, hooks_1.useRenderMatchPiece)();
    const renderBoardPiece = config.isMatch
        ? renderMatch
        : config.isInteractive
            ? renderSelectable
            : renderReadOnly;
    const renderBenchPiece = config.isInteractive
        ? renderSelectable
        : renderReadOnly;
    const onClickTile = (0, hooks_1.useOnClickTile)(surfaceBoard, bench, {
        canClickBoard: !config.isMatch,
    });
    const onDropPiece = (0, hooks_1.useOnDropPiece)(surfaceBoard, bench);
    return (react_1.default.createElement(plugins_1.Region, { cls: "board-surface", ctx: { isMatch: config.isMatch, isPreparing: config.isPreparing } },
        react_1.default.createElement(GameBoard_1.GameBoard, { board: surfaceBoard, bench: bench, pieceRegistry: pieceRegistry, renderBoardPiece: renderBoardPiece, renderBenchPiece: renderBenchPiece, onClick: config.isInteractive ? onClickTile : undefined, onDropPiece: config.isInteractive ? onDropPiece : undefined, boardDraggable: config.boardDraggable, benchDraggable: config.benchDraggable, showFiller: config.isPreparing },
            config.isMatch && react_1.default.createElement(ProjectileCanvas_1.ProjectileCanvas, null),
            children)));
}
